import request from '../utils/request'
import axios from 'axios'

// ==================== 客户管理 ====================

/**
 * 获取客户列表（业务员端）
 */
export function getCustomerList(params) {
  return request({
    url: '/salesman/customer/list',
    method: 'get',
    params
  })
}

/**
 * 获取客户详情
 */
export function getCustomerDetail(customerId) {
  return request({
    url: '/salesman/customer/detail',
    method: 'get',
    params: { customerId }
  })
}

/** 客户操作日志（公海/归属/资料变更等） */
export function getCustomerOperationLogs(customerId) {
  return request({
    url: '/salesman/customer/operation-logs',
    method: 'get',
    params: { customerId }
  })
}

/** 企业 CRM 字典元数据（绑定企业用户） */
export function getCustomerCrmMeta() {
  return request({
    url: '/salesman/customer/crm-meta',
    method: 'get'
  })
}

/**
 * 新增客户
 */
export function addCustomer(data) {
  return request({
    url: '/salesman/customer/add',
    method: 'post',
    data
  })
}

/**
 * 更新客户信息
 */
export function updateCustomer(data) {
  return request({
    url: '/salesman/customer/update-info',
    method: 'post',
    data
  })
}

/**
 * 删除客户
 */
export function deleteCustomer(customerId) {
  return request({
    url: '/salesman/customer/delete',
    method: 'post',
    params: { customerId }
  })
}

/**
 * 获取客户总数
 */
export function getCustomerCount() {
  return request({
    url: '/salesman/customer/count',
    method: 'get'
  })
}

/**
 * 获取客户分组列表（业务员端）
 */
export function getCustomerGroupList() {
  return request({
    url: '/salesman/customer-group/list',
    method: 'get'
  })
}

/**
 * 获取意向等级字典列表（业务员端）
 */
export function getIntentionLevels() {
  return request({
    url: '/salesman/intention-levels',
    method: 'get'
  })
}

/**
 * 获取地区子级列表（业务员端）
 */
export function getRegionChildren(parentId) {
  return request({
    url: '/salesman/region/children',
    method: 'get',
    params: { parentId: parentId || 0 }
  })
}

/**
 * 导出客户列表为Excel（业务员端）
 */
export function exportCustomerList(params) {
  // 创建独立的axios实例用于导出
  const baseURL = process.env.VUE_APP_BASE_API || 'http://localhost:8086'
  const token = localStorage.getItem('accessToken')
  
  return axios({
    url: `${baseURL}/salesman/customer/export`,
    method: 'get',
    params,
    responseType: 'blob',
    headers: {
      'Authorization': token ? `Bearer ${token}` : ''
    },
    timeout: 60000
  }).then(response => {
    const contentType = response.headers['content-type'] || response.headers['Content-Type'] || ''
    if (contentType.includes('application/json')) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onload = () => {
          try {
            const errorData = JSON.parse(reader.result)
            reject(new Error(errorData.msg || errorData.message || '导出失败'))
          } catch (e) {
            reject(new Error('导出失败：服务器返回了无效的响应'))
          }
        }
        reader.onerror = () => reject(new Error('导出失败：无法读取服务器响应'))
        reader.readAsText(response.data)
      })
    }
    return response.data
  }).catch(error => {
    // 处理HTTP错误响应
    if (error.response) {
      const { data, status, headers } = error.response
      const contentType = headers['content-type'] || headers['Content-Type'] || ''
      
      // 如果响应是Blob类型，尝试解析为JSON
      if (data instanceof Blob) {
        return new Promise((resolve, reject) => {
          const reader = new FileReader()
          reader.onload = () => {
            try {
              const text = reader.result
              // 尝试解析为JSON
              const errorData = JSON.parse(text)
              reject(new Error(errorData.msg || errorData.message || '导出失败'))
            } catch (e) {
              // 如果不是JSON，检查Content-Type
              if (contentType.includes('application/json')) {
                reject(new Error('导出失败：无法解析服务器响应'))
              } else {
                reject(new Error(`导出失败：HTTP ${status}`))
              }
            }
          }
          reader.onerror = () => reject(new Error('导出失败：无法读取服务器响应'))
          reader.readAsText(data)
        })
      }
      
      // 如果响应是JSON格式
      if (contentType.includes('application/json')) {
        const errorMsg = data.msg || data.message || `导出失败：HTTP ${status}`
        return Promise.reject(new Error(errorMsg))
      }
    }
    
    // 处理网络错误或其他错误
    if (error.message && error.message.includes('Network Error')) {
      return Promise.reject(new Error('网络错误，请检查网络连接'))
    }
    
    throw error
  })
}

/**
 * 下载客户导入模板
 */
export function downloadCustomerImportTemplate() {
  const baseURL = process.env.VUE_APP_BASE_API || 'http://localhost:8086'
  const token = localStorage.getItem('accessToken')
  
  return axios({
    url: `${baseURL}/salesman/customer/import-template`,
    method: 'get',
    responseType: 'blob',
    headers: {
      'Authorization': token ? `Bearer ${token}` : ''
    },
    timeout: 30000
  }).then(response => {
    const contentType = response.headers['content-type'] || response.headers['Content-Type'] || ''
    if (contentType.includes('application/json')) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onload = () => {
          try {
            const errorData = JSON.parse(reader.result)
            reject(new Error(errorData.msg || errorData.message || '下载失败'))
          } catch (e) {
            resolve(response.data)
          }
        }
        reader.onerror = () => resolve(response.data)
        reader.readAsText(response.data)
      })
    }
    return response.data
  })
}

/**
 * 导入客户列表
 */
export function importCustomerList(file) {
  const baseURL = process.env.VUE_APP_BASE_API || 'http://localhost:8086'
  const token = localStorage.getItem('accessToken')
  
  const formData = new FormData()
  formData.append('file', file)
  
  return axios({
    url: `${baseURL}/salesman/customer/import`,
    method: 'post',
    data: formData,
    headers: {
      'Authorization': token ? `Bearer ${token}` : '',
      'Content-Type': 'multipart/form-data'
    },
    timeout: 120000
  })
}

/**
 * 获取导入记录列表
 */
export function getImportRecords(params) {
  return request({
    url: '/salesman/customer/import-records',
    method: 'get',
    params
  })
}

// ==================== 合同管理 ====================

/**
 * 获取合同列表（业务员端）
 */
export function getContractList(params) {
  return request({
    url: '/salesman/contract/list',
    method: 'get',
    params
  })
}

/**
 * 获取合同详情
 */
export function getContractDetail(contractId) {
  return request({
    url: '/salesman/contract/detail',
    method: 'get',
    params: { contractId }
  })
}

/**
 * 创建合同
 */
export function createContract(data) {
  return request({
    url: '/salesman/contract/create',
    method: 'post',
    data
  })
}

/**
 * 更新合同
 */
export function updateContract(data) {
  return request({
    url: '/salesman/contract/update',
    method: 'post',
    data
  })
}

/**
 * 撤销合同
 */
export function withdrawContract(contractId) {
  return request({
    url: '/salesman/contract/withdraw',
    method: 'post',
    params: { contractId }
  })
}

/**
 * 获取合同总数
 */
export function getContractCount() {
  return request({
    url: '/salesman/contract/count',
    method: 'get'
  })
}

/**
 * 导出合同列表为Excel（业务员端）
 */
export function exportContractList(params) {
  // 创建独立的axios实例用于导出
  const baseURL = process.env.VUE_APP_BASE_API || 'http://localhost:8086'
  const token = localStorage.getItem('accessToken')
  
  return axios({
    url: `${baseURL}/salesman/contract/export`,
    method: 'get',
    params,
    responseType: 'blob',
    headers: {
      'Authorization': token ? `Bearer ${token}` : ''
    },
    timeout: 60000
  }).then(response => {
    const contentType = response.headers['content-type'] || response.headers['Content-Type'] || ''
    if (contentType.includes('application/json')) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onload = () => {
          try {
            const errorData = JSON.parse(reader.result)
            reject(new Error(errorData.msg || errorData.message || '导出失败'))
          } catch (e) {
            reject(new Error('导出失败：服务器返回了无效的响应'))
          }
        }
        reader.onerror = () => reject(new Error('导出失败：无法读取服务器响应'))
        reader.readAsText(response.data)
      })
    }
    return response.data
  }).catch(error => {
    // 处理HTTP错误响应
    if (error.response) {
      const { data, status, headers } = error.response
      const contentType = headers['content-type'] || headers['Content-Type'] || ''
      
      // 如果响应是Blob类型，尝试解析为JSON
      if (data instanceof Blob) {
        return new Promise((resolve, reject) => {
          const reader = new FileReader()
          reader.onload = () => {
            try {
              const text = reader.result
              // 尝试解析为JSON
              const errorData = JSON.parse(text)
              reject(new Error(errorData.msg || errorData.message || '导出失败'))
            } catch (e) {
              // 如果不是JSON，检查Content-Type
              if (contentType.includes('application/json')) {
                reject(new Error('导出失败：无法解析服务器响应'))
              } else {
                reject(new Error(`导出失败：HTTP ${status}`))
              }
            }
          }
          reader.onerror = () => reject(new Error('导出失败：无法读取服务器响应'))
          reader.readAsText(data)
        })
      }
      
      // 如果响应是JSON格式
      if (contentType.includes('application/json')) {
        const errorMsg = data.msg || data.message || `导出失败：HTTP ${status}`
        return Promise.reject(new Error(errorMsg))
      }
    }
    
    // 处理网络错误或其他错误
    if (error.message && error.message.includes('Network Error')) {
      return Promise.reject(new Error('网络错误，请检查网络连接'))
    }
    
    throw error
  })
}

/**
 * 获取审批记录
 */
export function getApprovalRecords(businessType, businessId) {
  return request({
    url: '/workflow/approval-records',
    method: 'get',
    params: { businessType, businessId }
  })
}

/**
 * 检查是否需要审批
 */
export function checkNeedApproval(businessType, businessId) {
  return request({
    url: '/workflow/check-need-approval',
    method: 'get',
    params: { businessType, businessId }
  })
}

// ==================== 跟进管理 ====================

/**
 * 获取跟进列表（业务员端）
 */
export function getFollowList(params) {
  return request({
    url: '/salesman/follow/list',
    method: 'get',
    params
  })
}

/**
 * 获取跟进详情
 */
export function getFollowDetail(id) {
  return request({
    url: '/salesman/follow/detail',
    method: 'get',
    params: { id }
  })
}

/**
 * 新增跟进
 */
export function addFollow(data) {
  return request({
    url: '/salesman/follow/add',
    method: 'post',
    data
  })
}

/**
 * 更新跟进
 */
export function updateFollow(data) {
  return request({
    url: '/salesman/follow/update',
    method: 'post',
    data
  })
}

/**
 * 获取跟进统计
 */
export function getFollowStatistics() {
  return request({
    url: '/salesman/follow/statistics',
    method: 'get'
  })
}

/**
 * 导出跟进列表为Excel（业务员端）
 */
export function exportFollowList(params) {
  const baseURL = process.env.VUE_APP_BASE_API || 'http://localhost:8086'
  const token = localStorage.getItem('accessToken')
  
  return axios({
    url: `${baseURL}/salesman/follow/export`,
    method: 'get',
    params,
    responseType: 'blob',
    headers: {
      'Authorization': token ? `Bearer ${token}` : ''
    },
    timeout: 60000
  }).then(response => {
    const contentType = response.headers['content-type'] || response.headers['Content-Type'] || ''
    if (contentType.includes('application/json')) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onload = () => {
          try {
            const errorData = JSON.parse(reader.result)
            reject(new Error(errorData.msg || errorData.message || '导出失败'))
          } catch (e) {
            reject(new Error('导出失败：服务器返回了无效的响应'))
          }
        }
        reader.onerror = () => reject(new Error('导出失败：无法读取服务器响应'))
        reader.readAsText(response.data)
      })
    }
    return response.data
  }).catch(error => {
    if (error.response) {
      const { data, status, headers } = error.response
      const contentType = headers['content-type'] || headers['Content-Type'] || ''
      
      if (data instanceof Blob) {
        return new Promise((resolve, reject) => {
          const reader = new FileReader()
          reader.onload = () => {
            try {
              const text = reader.result
              const errorData = JSON.parse(text)
              reject(new Error(errorData.msg || errorData.message || '导出失败'))
            } catch (e) {
              if (contentType.includes('application/json')) {
                reject(new Error('导出失败：无法解析服务器响应'))
              } else {
                reject(new Error(`导出失败：HTTP ${status}`))
              }
            }
          }
          reader.onerror = () => reject(new Error('导出失败：无法读取服务器响应'))
          reader.readAsText(data)
        })
      }
      
      if (contentType.includes('application/json')) {
        const errorMsg = data.msg || data.message || `导出失败：HTTP ${status}`
        return Promise.reject(new Error(errorMsg))
      }
    }
    
    if (error.message && error.message.includes('Network Error')) {
      return Promise.reject(new Error('网络错误，请检查网络连接'))
    }
    
    throw error
  })
}

// ==================== 报销申请 ====================

/**
 * 获取报销申请列表（业务员端）
 */
export function getTravelExpenseList(params) {
  return request({
    url: '/salesman/travel-expense/list',
    method: 'get',
    params
  })
}

/**
 * 获取报销申请详情
 */
export function getTravelExpenseDetail(id) {
  return request({
    url: '/salesman/travel-expense/detail',
    method: 'get',
    params: { id }
  })
}

/**
 * 创建报销申请
 */
export function createTravelExpense(data) {
  return request({
    url: '/salesman/travel-expense/create',
    method: 'post',
    data
  })
}

/**
 * 更新报销申请
 */
export function updateTravelExpense(data) {
  return request({
    url: '/salesman/travel-expense/update',
    method: 'post',
    data
  })
}

/**
 * 提交报销申请
 */
export function submitTravelExpense(data) {
  return request({
    url: '/salesman/travel-expense/submit',
    method: 'post',
    data
  })
}

/**
 * 撤销报销申请
 */
export function withdrawTravelExpense(id) {
  return request({
    url: '/salesman/travel-expense/withdraw',
    method: 'post',
    params: { id }
  })
}

// ==================== 出差申请 ====================

/**
 * 获取出差申请列表（业务员端）
 */
export function getBusinessTripList(params) {
  return request({
    url: '/salesman/business-trip/list',
    method: 'get',
    params
  })
}

/**
 * 获取出差申请详情
 */
export function getBusinessTripDetail(id) {
  return request({
    url: '/salesman/business-trip/detail',
    method: 'get',
    params: { id }
  })
}

/**
 * 创建出差申请
 */
export function createBusinessTrip(data) {
  return request({
    url: '/salesman/business-trip/create',
    method: 'post',
    data
  })
}

/**
 * 更新出差申请
 */
export function updateBusinessTrip(data) {
  return request({
    url: '/salesman/business-trip/update',
    method: 'post',
    data
  })
}

/**
 * 提交出差申请
 */
export function submitBusinessTrip(data) {
  return request({
    url: '/salesman/business-trip/submit',
    method: 'post',
    data
  })
}

/**
 * 撤销出差申请
 */
export function withdrawBusinessTrip(id) {
  return request({
    url: '/salesman/business-trip/withdraw',
    method: 'post',
    params: { id }
  })
}

// ==================== 返货管理 ====================

/**
 * 获取返货单列表（业务员端）
 */
export function getReturnOrderList(params) {
  return request({
    url: '/salesman/return-order/list',
    method: 'get',
    params
  })
}

/**
 * 获取返货单详情
 */
export function getReturnOrderDetail(id) {
  return request({
    url: '/salesman/return-order/detail',
    method: 'get',
    params: { id }
  })
}

/**
 * 创建返货单
 */
export function createReturnOrder(data) {
  return request({
    url: '/salesman/return-order/create',
    method: 'post',
    data
  })
}

/**
 * 更新返货单
 */
export function updateReturnOrder(data) {
  return request({
    url: '/salesman/return-order/update',
    method: 'post',
    data
  })
}

/**
 * 提交返货单
 */
export function submitReturnOrder(data) {
  return request({
    url: '/salesman/return-order/submit',
    method: 'post',
    data
  })
}

/**
 * 撤销返货单（退回草稿）
 */
export function withdrawReturnOrder(data) {
  return request({
    url: '/salesman/return-order/cancel',
    method: 'post',
    data
  })
}

/**
 * 获取仓库列表（业务员端，用于返货单选择仓库）
 */
export function getWarehouseListForSalesman(params) {
  return request({
    url: '/salesman/warehouse/list',
    method: 'get',
    params
  })
}

/**
 * 获取商品列表（业务员端，用于返货单选择商品）
 */
export function getProductListForSalesman(params) {
  return request({
    url: '/salesman/product/list',
    method: 'get',
    params
  })
}

/**
 * 导出返货单列表为Excel（业务员端）
 */
export function exportReturnOrderList(params) {
  const baseURL = process.env.VUE_APP_BASE_API || 'http://localhost:8086'
  const token = localStorage.getItem('accessToken')
  
  return axios({
    url: `${baseURL}/salesman/return-order/export`,
    method: 'get',
    params,
    responseType: 'blob',
    headers: {
      'Authorization': token ? `Bearer ${token}` : ''
    },
    timeout: 60000
  }).then(response => {
    const contentType = response.headers['content-type'] || response.headers['Content-Type'] || ''
    if (contentType.includes('application/json')) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onload = () => {
          try {
            const errorData = JSON.parse(reader.result)
            reject(new Error(errorData.msg || errorData.message || '导出失败'))
          } catch (e) {
            reject(new Error('导出失败：服务器返回了无效的响应'))
          }
        }
        reader.onerror = () => reject(new Error('导出失败：无法读取服务器响应'))
        reader.readAsText(response.data)
      })
    }
    return response.data
  }).catch(error => {
    if (error.response) {
      const { data, status, headers } = error.response
      const contentType = headers['content-type'] || headers['Content-Type'] || ''
      
      if (data instanceof Blob) {
        return new Promise((resolve, reject) => {
          const reader = new FileReader()
          reader.onload = () => {
            try {
              const text = reader.result
              const errorData = JSON.parse(text)
              reject(new Error(errorData.msg || errorData.message || '导出失败'))
            } catch (e) {
              if (contentType.includes('application/json')) {
                reject(new Error('导出失败：无法解析服务器响应'))
              } else {
                reject(new Error(`导出失败：HTTP ${status}`))
              }
            }
          }
          reader.onerror = () => reject(new Error('导出失败：无法读取服务器响应'))
          reader.readAsText(data)
        })
      }
      
      if (contentType.includes('application/json')) {
        const errorMsg = data.msg || data.message || `导出失败：HTTP ${status}`
        return Promise.reject(new Error(errorMsg))
      }
    }
    
    if (error.message && error.message.includes('Network Error')) {
      return Promise.reject(new Error('网络错误，请检查网络连接'))
    }
    
    throw error
  })
}

/**
 * 导出商品列表为Excel（业务员端）
 */
export function exportProductList(params) {
  const baseURL = process.env.VUE_APP_BASE_API || 'http://localhost:8086'
  const token = localStorage.getItem('accessToken')
  
  return axios({
    url: `${baseURL}/salesman/product/export`,
    method: 'get',
    params,
    responseType: 'blob',
    headers: {
      'Authorization': token ? `Bearer ${token}` : ''
    },
    timeout: 60000
  }).then(response => {
    const contentType = response.headers['content-type'] || response.headers['Content-Type'] || ''
    if (contentType.includes('application/json')) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onload = () => {
          try {
            const errorData = JSON.parse(reader.result)
            reject(new Error(errorData.msg || errorData.message || '导出失败'))
          } catch (e) {
            reject(new Error('导出失败：服务器返回了无效的响应'))
          }
        }
        reader.onerror = () => reject(new Error('导出失败：无法读取服务器响应'))
        reader.readAsText(response.data)
      })
    }
    return response.data
  }).catch(error => {
    if (error.response) {
      const { data, status, headers } = error.response
      const contentType = headers['content-type'] || headers['Content-Type'] || ''
      
      if (data instanceof Blob) {
        return new Promise((resolve, reject) => {
          const reader = new FileReader()
          reader.onload = () => {
            try {
              const text = reader.result
              const errorData = JSON.parse(text)
              reject(new Error(errorData.msg || errorData.message || '导出失败'))
            } catch (e) {
              if (contentType.includes('application/json')) {
                reject(new Error('导出失败：无法解析服务器响应'))
              } else {
                reject(new Error(`导出失败：HTTP ${status}`))
              }
            }
          }
          reader.onerror = () => reject(new Error('导出失败：无法读取服务器响应'))
          reader.readAsText(data)
        })
      }
      
      if (contentType.includes('application/json')) {
        const errorMsg = data.msg || data.message || `导出失败：HTTP ${status}`
        return Promise.reject(new Error(errorMsg))
      }
    }
    
    if (error.message && error.message.includes('Network Error')) {
      return Promise.reject(new Error('网络错误，请检查网络连接'))
    }
    
    throw error
  })
}

// ==================== 成交台账 ====================

/**
 * 获取成交台账列表（业务员端）
 */
export function getDealRecordList(params) {
  return request({
    url: '/salesman/deal-record/list',
    method: 'get',
    params
  })
}

/**
 * 获取成交台账详情
 */
export function getDealRecordDetail(id) {
  return request({
    url: '/salesman/deal-record/detail',
    method: 'get',
    params: { id }
  })
}

/**
 * 创建成交台账
 */
export function createDealRecord(data) {
  return request({
    url: '/salesman/deal-record/create',
    method: 'post',
    data
  })
}

/**
 * 更新成交台账
 */
export function updateDealRecord(data) {
  return request({
    url: '/salesman/deal-record/update',
    method: 'post',
    data
  })
}

/**
 * 撤销成交台账（退回草稿）
 */
export function withdrawDealRecord(id) {
  return request({
    url: '/salesman/deal-record/withdraw',
    method: 'post',
    params: { id }
  })
}

/**
 * 删除成交台账
 */
export function deleteDealRecord(id) {
  return request({
    url: '/salesman/deal-record/delete',
    method: 'post',
    params: { id }
  })
}

// ==================== 数据报表 ====================

/**
 * 获取数据报表统计
 */
export function getStatistics(params) {
  return request({
    url: '/salesman/report/statistics',
    method: 'get',
    params
  })
}

/**
 * 导出成交台账列表为Excel（业务员端）
 */
export function exportDealRecordList(params) {
  const baseURL = process.env.VUE_APP_BASE_API || 'http://localhost:8086'
  const token = localStorage.getItem('accessToken')
  
  return axios({
    url: `${baseURL}/salesman/deal-record/export`,
    method: 'get',
    params,
    responseType: 'blob',
    headers: {
      'Authorization': token ? `Bearer ${token}` : ''
    },
    timeout: 60000
  }).then(response => {
    const contentType = response.headers['content-type'] || response.headers['Content-Type'] || ''
    if (contentType.includes('application/json')) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onload = () => {
          try {
            const errorData = JSON.parse(reader.result)
            reject(new Error(errorData.msg || errorData.message || '导出失败'))
          } catch (e) {
            reject(new Error('导出失败：服务器返回了无效的响应'))
          }
        }
        reader.onerror = () => reject(new Error('导出失败：无法读取服务器响应'))
        reader.readAsText(response.data)
      })
    }
    return response.data
  }).catch(error => {
    if (error.response) {
      const { data, status, headers } = error.response
      const contentType = headers['content-type'] || headers['Content-Type'] || ''
      
      if (data instanceof Blob) {
        return new Promise((resolve, reject) => {
          const reader = new FileReader()
          reader.onload = () => {
            try {
              const text = reader.result
              const errorData = JSON.parse(text)
              reject(new Error(errorData.msg || errorData.message || '导出失败'))
            } catch (e) {
              if (contentType.includes('application/json')) {
                reject(new Error('导出失败：无法解析服务器响应'))
              } else {
                reject(new Error(`导出失败：HTTP ${status}`))
              }
            }
          }
          reader.onerror = () => reject(new Error('导出失败：无法读取服务器响应'))
          reader.readAsText(data)
        })
      }
      
      if (contentType.includes('application/json')) {
        const errorMsg = data.msg || data.message || `导出失败：HTTP ${status}`
        return Promise.reject(new Error(errorMsg))
      }
    }
    
    if (error.message && error.message.includes('Network Error')) {
      return Promise.reject(new Error('网络错误，请检查网络连接'))
    }
    
    throw error
  })
}

